import axios from "axios";

export const getAllSkills = async () => {
  const skills = await axios.get("/skills/all-skills");
  return skills.data;
};

export const addSkills = async (skills) => {
  return await axios.post("/skills/add-skills", skills);
};

export const getPaginatedSkills = async (query) => {
  const skills = await axios.get("/skills/paginated", { params: query });
  return skills?.data;
};

export const deleteSkills = async (skillIds) => {
  return await axios.delete("/skills", { data: { skillIds } });
};
